import axios from '@utils/axios';
import router from '@router/router';

const resultsDetail = {
  state: {
    resultId: 0,
    status: 1,
    paired: '',
    unpairable: '',
    generated: '',
    toBeGenerated: '',
    uploadedAt: '',
    exception: ''
  },
  mutations: {
    setResultId(state, id) {
      state.resultId = id;
    },
    setStatus(state, status) {
      state.status = status;
    },
    setPaired(state, paired) {
      state.paired = paired;
    },
    setUnpairable(state, unpairable) {
      state.unpairable = unpairable;
    },
    setGenerated(state, generated) {
      state.generated = generated;
    },
    setToBeGenerated(state, toBeGenerated) {
      state.toBeGenerated = toBeGenerated;
    },
    setUploadedAt(state, at) {
      state.uploadedAt = at;
    },
    setException(state, exception) {
      state.exception = exception;
    }
  },
  actions: {
    fetchResult(context) {
      return axios.get('admin/results/getresult', {
        params: {
          Id: context.state.resultId
        }
      })
        .then((res) => {
          if (res.status === 404) {
            router.push({ name: 'admin.results.view' });
          } else if (res.status === 200) {
            context.commit('setStatus', res.data.result.status);
            context.commit('setPaired', res.data.result.paired.join(', '));
            context.commit('setUnpairable', res.data.result.unpairable.join(', '));
            context.commit('setGenerated', res.data.result.generated.join(', '));
            context.commit('setToBeGenerated', res.data.result.toBeGenerated.join(', '));
            context.commit('setUploadedAt', res.data.result.uploadedAt);
            context.commit('setException', res.data.result.exception);
            Promise.resolve(true);
          }
        }).catch(() => {
          router.push({ name: 'admin.dashboard' });
        });
    },
    resetContext(context) {
      context.commit('setStatus', 1);
      context.commit('setPaired', '');
      context.commit('setUnpairable', '');
      context.commit('setGenerated', '');
      context.commit('setToBeGenerated', '');
      context.commit('setUploadedAt', '');
      context.commit('setException', '');
    }
  },
  namespaced: true
};

export default resultsDetail;
